/* External */
import { createContext, useContext } from 'react';

/* Utils */
import { noOp } from '../../utils/functions';

export const ScrollContext = createContext({
  scrollPixels: (pixels, childScrollPixels) => childScrollPixels && childScrollPixels(pixels),
  scrollIntoView: noOp,
});

export function useScrollPixels() {
  const { scrollPixels } = useContext(ScrollContext);
  return scrollPixels;
}

export function useScrollIntoView() {
  const { scrollIntoView } = useContext(ScrollContext);
  return scrollIntoView;
}
